export default "https://cdn-static.gokick.com/assets/0f3104c02f0c7e58561d070a1e1ba5e916429e4c/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";